// Library Imports
import React, { useContext } from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import { Tooltip } from '@mui/material'
import * as BsIcons from 'react-icons/bs'

// Context Imports
import { ListContext } from '../../contexts/ListContext'

// Asset Imports'
import '../../assets/css/stylesheets/components/sort/ListSort.css'

function ListSort() {
    const {
        sortDirection,
        setSortDirection,
        displayOption,
        setDisplayOption,
        resultsCount
    } = useContext(ListContext)

    function handleSortDirectionChanged(e) {
        setSortDirection(e.target.value);
    }

    function handleDisplayOptionChanged(e) {
        setDisplayOption(e.target.value);
    }

    return (
        <Container className='listsort'>
            <Row>
                <Col className='d-flex align-self-center' xs={12} sm={12} md={6} lg={6} xl={6}>
                    <h6 className='listsort-results'>Showing Filtered Results: {resultsCount}</h6>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                    <div className='listsort-sorts'>
                        <Form.Select 
                            value={sortDirection} 
                            onChange={handleSortDirectionChanged}>
                            <option value='nameAZ'>Name (A-Z)</option>
                            <option value='nameZA'>Name (Z-A)</option>
                            <option value='latest'>Recently Added (Latest)</option>
                            <option value='oldest'>Date Added (Oldest)</option>
                        </Form.Select>
                        <Tooltip title="List" arrow>
                            <Button 
                                className='listsort-button' 
                                value="list" 
                                onClick={handleDisplayOptionChanged}>
                                <BsIcons.BsListUl />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Grid" arrow>
                            <Button className='listsort-button' 
                            value="grid" 
                            onClick={handleDisplayOptionChanged} >
                                <BsIcons.BsGridFill />
                            </Button>
                        </Tooltip>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default ListSort